import cn from 'clsx';
import { cva, type VariantProps } from 'class-variance-authority';
import { ImageDisturber } from '@ev-tech/search-modules-api';

import { BadgeSize, type BadgeVariant } from './Badge.types';

import styles from './Badge.module.css';

const badgeVariants = cva(cn(styles.baseClass, styles.propertyBadge), {
  variants: {
    variant: {
      [ImageDisturber.NEW]: styles.new,
      [ImageDisturber.PRICE_UPDATED]: styles.new,
      [ImageDisturber.EXCLUSIVE]: styles.exclusive,
      [ImageDisturber.RESERVED]: styles.reserved,
      [ImageDisturber.SOLD]: styles.sold,
      [ImageDisturber.RENTED_OUT]: styles.rentedOut,
      [ImageDisturber.UNLOCKED]: styles.unlocked,
    },
    size: {
      [BadgeSize.S]: styles.small,
      [BadgeSize.M]: styles.medium,
    },
  },
  defaultVariants: {
    variant: ImageDisturber.NEW,
    size: BadgeSize.S,
  },
});

export type BadgeProps = VariantProps<typeof badgeVariants> & {
  className?: string;
  label?: string;
  'data-testid'?: string;
};

export { BadgeSize };
export type { BadgeVariant };

export const Badge = ({ className, label, variant, size, 'data-testid': dataTestId }: BadgeProps) => {
  return (
    <span className={cn(badgeVariants({ variant, size }), className)} data-testid={dataTestId}>
      {label}
    </span>
  );
};
